export const statusToText = (status: boolean): string => {
    if (status)
        return "Ativo";
    return "Inativo";
};